

import { groupBy } from 'lodash'
import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

const useSandreTaxonsSize = () => {
    const {
        sandreCodes,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    const sandreTaxonSizeGroup = useMemo(() => {
        const filteredSandreCodes = sandreCodes.filter(sc => sc.field.startsWith('TAXONS.') && sc.field.endsWith('.TAILLE'))
        return groupBy(filteredSandreCodes, sc => sc.field.split('.')[1])
    }, [sandreCodes])

    return sandreTaxonSizeGroup
}

export default useSandreTaxonsSize